/*

jv.Common.Directives.MessageTemplate Module
===========================================

Collection of directives that help with setting values of other
fields when a select2 value is selected. Ideally, this will be used
with the select2 directive.

Usage
-----

<div jv-message-template="<ID>" jv-select2 jv-select2-objects jv-select2-data="tplData" ng-model="modelVal"></div>
<input jv-message-template-select="<ID>" jv-message-template-value="<key>" />

Options
-------
-	ID: unique string per jv-message-template instance
-	key: they key in jv-message-template ng-model data that this field
	should be populated with when jv-message-template ng-model changes

 */
angular.module('jv.Common.Directives.MessageTemplate', [])

.directive('jvMessageTemplate', [function(){
	return {
		require: 'ngModel',
		link: function($scope, iElm, iAttrs, ngModel) {
			$scope.$watch(iAttrs.ngModel, function(val) {
				$scope.$broadcast('templateChanged', iAttrs.jvMessageTemplate, val);
			});
		}
	};
}])

.directive('jvMessageTemplateSelect', ['$parse', function($parse){
	return {
		require: 'ngModel',
		link: function($scope, iElm, iAttrs) {
			var ngModel = $parse(iAttrs.ngModel);
			$scope.$on('templateChanged', function(e, select, val) {
				var newVal = '';
				if(typeof(val)==='string'){
					val = $scope.$eval(val);
				}
				if (select !== iAttrs.jvMessageTemplateSelect) {
					return;
				}

				if (val && val[iAttrs.jvMessageTemplateValue]) {
					newVal = val[iAttrs.jvMessageTemplateValue];
				}
				ngModel.assign($scope, newVal);
			});
		}
	};
}]);